import Icon from '@mdi/react';
import { mdiBookOutline, mdiFilePdfOutline, mdiImageOutline } from '@mdi/js';
import { MemberBooking } from '@shared/integrations/taf-api/v1/models';
import { useFetchEventMaterial } from '@my-pages/features/courses/libs/react-query/useFetchEventMaterials.tsx';
import { formatDate } from '@shared/utils/dateUtils.ts';

interface IProps {
    course: MemberBooking;
}

const materialTypeIcon = (materialType: string) => {
    switch (materialType) {
        case 'umbracoMediaArticle':
            return (
                <Icon
                    path={mdiFilePdfOutline}
                    className='mdi'
                />
            );
        case 'Image':
            return (
                <Icon
                    path={mdiImageOutline}
                    className='mdi'
                />
            );
        default:
            return <></>;
    }
};

const CourseCard = ({ course }: IProps) => {
    const { startDate, endDate, courseName, hasParticipated, reservationStatus, courseCity, eventId } = course;
    const { eventMaterial } = useFetchEventMaterial(eventId ?? '', hasParticipated);
    const showMaterial = new Date(startDate ?? '') > new Date('2024-01-01');
    return (
        <div className='col-xl-6 mb-4'>
            <div className='click-item flex-column h-100'>
                <h5 className='d-flex mt-3'>
                    <div className='icon-round mr-3'>
                        <Icon
                            path={mdiBookOutline}
                            className='mdi'
                        />
                    </div>
                    <span className='align-self-center'>{courseName}</span>
                </h5>
                <div className='ft-table ft-responsive-sm table-mark-empty mb-0 font-size-sm'>
                    <div className='ft-tbody'>
                        {!hasParticipated && (
                            <div className='ft-tr'>
                                <div className='ft-th'>Start- och slutdatum</div>
                                <div className='ft-td w-sm-75'>
                                    <span data-toggle-tooltip='tooltip'>{startDate ? formatDate(startDate) : 'N/A'}</span>
                                    {' till '}
                                    <span data-toggle-tooltip='tooltip'>{endDate ? formatDate(endDate) : 'N/A'}</span>
                                </div>
                            </div>
                        )}
                        {hasParticipated && (
                            <div className='ft-tr'>
                                <div className='ft-th'>Genomförd</div>
                                <div className='ft-td w-sm-75'>
                                    <span data-toggle-tooltip='tooltip'>{startDate ? formatDate(startDate) : 'N/A'}</span>
                                    {' till '}
                                    <span data-toggle-tooltip='tooltip'>{endDate ? formatDate(endDate) : 'N/A'}</span>
                                </div>
                            </div>
                        )}
                        <div className='ft-tr'>
                            <div className='ft-th'>Plats</div>
                            <div className='ft-td w-sm-75'>{courseCity}</div>
                        </div>
                        {!hasParticipated && (
                            <div className='ft-tr'>
                                <div className='ft-th'>Status</div>
                                <div className='ft-td w-sm-75'>{reservationStatus}</div>
                            </div>
                        )}
                    </div>
                    {eventMaterial && hasParticipated && showMaterial && (
                        <>
                            <div className='ft-tr'>
                                <div className='ft-th'>Kursmaterial</div>
                                <div className='ft-td w-sm-75'>
                                    <div className='d-flex flex-column gap-2'>
                                        {eventMaterial.map((material, key) => (
                                            <a
                                                href={material.url}
                                                className='d-flex gap-2 border-0'
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                key={key}
                                            >
                                                {materialTypeIcon(material.materialType ?? '')}
                                                <span>
                                                    <span className='border-bottom border-primary'>{material.name}</span>
                                                </span>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CourseCard;
